export default {
  noAlarms: 'Nenašli sa žiadne aktívne alarmy',
  activeAlarms: 'Aktívne alarmy',
  acknowledgeAll: 'Potvrdiť všetky',
  enableNotificationsForNewAlarms: 'Upozorniť na alarmy',
  enableNotificationsForNewAlarmsTooltip: 'Zobraziť upozornenie v prehliadači pri výskyte nového alarmu.',
  newAlarmNotificationTitle: 'Nový alarm',
  notificationsPermissionDeniedTooltip: 'V prehliadači ste nepovolili upozornenia.',
  notificationsPermissionUnsupportedTooltip: 'Váš prehliadač nepodporuje upozornenia.',
};
